import { getCaseItemDetails_caseItem } from 'Constants/graphql/queries/detail/__generated__/getCaseItemDetails'
import { SHIPPING_PROVIDERS } from 'Constants/ShippingProviders'

export const shouldShowTracking = (caseItem: getCaseItemDetails_caseItem) => {
  if (!caseItem.shipping?.trackingURL) {
    return false
  }

  switch (caseItem.shipping.serviceProvider) {
    case SHIPPING_PROVIDERS.DHL:
    case SHIPPING_PROVIDERS.DHL_DE_PAKET:
    case SHIPPING_PROVIDERS.DHL_EXPRESS:
    case SHIPPING_PROVIDERS.DHL_EXPRESS_DE:
    case SHIPPING_PROVIDERS.DHL_EXPRESS_DE_TO_DE:
    case SHIPPING_PROVIDERS.DHL_EXPRESS_DE_TO_EU:
    case SHIPPING_PROVIDERS.DHL_INTERNATIONAL:
      return true
    default:
      return false
  }
}
